<template>
  <div class="shipment-tag-jadlog-smartlabel bgModelo">
    <div class="shipment-root">
      <div class="row">
        <div class="wrapper-outer">
          <div class="wrapper-inner">
            <img :src="shippingCompanyIcon" class="in-center jadlog-header-logo" />
          </div>
          <div class="wrapper-inner">
            <img :src="tag.companyIcon" class="in-center jadlog-header-logo" />
          </div>
        </div>
      </div>
      <div class="container-information">
        <div class="wrapper-inner">
          <div class="row box-double-content height-large">
            <div class="wrapper-outer">
              <ul class="sender-info">
                <li>
                  {{`${tag.to.address}, ${tag.to.locationNumber}`}}
                </li>
                <li>
                  <template v-if="tag.to.complement">
                    {{tag.to.complement + ', '}}
                  </template>
                  {{tag.to.district}}
                </li>
                <li>
                  <strong>
                    {{beautifyPostalCode(tag.to.postalCode)}}
                  </strong>
                  {{tag.to.city}}
                  <template v-if="tag.to.stateAbbr">
                    {{'/ ' + tag.to.stateAbbr}}
                  </template>
                </li>
                <li class="sender-obs" v-if="tag.to.note">
                  <strong>obs:</strong> {{tag.to.note}}
                </li>
              </ul>
            </div>
          </div>
          <div class="row box-between height-medium">
            <div class="wrapper-outer">
              <ul class="recipient-contact-wrapper">
                <li class="font-little">
                  Contato:
                  <div class="name">{{tag.to.name}}</div>
                </li>
                <li class="font-little">
                  Telefone:
                  <span class="phone" v-if="tag.to.phone">{{maskPhone(tag.to.phone)}}</span>
                </li>
              </ul>
              <ul>
                <li class="font-little">Pacotes</li>
              </ul>
            </div>
          </div>
          <div class="row box-between">
            <div class="wrapper-outer">
              <ul class="shipping-info">
                <li class="shipping-info__type">
                  <span v-if="tag.invoice.number">NF: {{ tag.invoice.number }}</span>
                  <span v-if="$parent.$parent.chkChave">DECLARACAO</span>
                </li>
                <li class="shipping-info__invoice">
                  {{tag.invoice.number}}
                </li>
              </ul>
              <ul>
                <li>1</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="wrapper-inner">
          <div class="row">
            <div class="wrapper-outer horizontal-wrapper horizontal-wrapper--empty">
              <h2></h2>
              <h3></h3>
            </div>
          </div>
          <div class="row">
            <div class="wrapper-outer horizontal-wrapper">
              <p>{{tag.from.name}}</p>
              <p v-if="tag.from.phone">
                {{maskPhone(tag.from.phone)}}
              </p>
              <p>
                {{tag.from.address}}
                <template v-if="tag.from.locationNumber">
                  {{', ' + tag.from.locationNumber}}
                </template>
                {{tag.from.complement}}
                <template v-if="tag.from.district">
                {{', ' + tag.from.district}}
                </template>
              </p>
              <p>
                {{beautifyPostalCode(tag.from.postalCode)}}
                {{tag.from.city}}
                <template v-if="tag.from.stateAbbr.length">
                {{'/' + tag.from.stateAbbr}}
                </template>
              </p>
            </div>
          </div>
        </div>
        <div class="wrapper-inner">
          <div class="bar-code">
            <canvas
              class="barcode img-code"
              data-value="000000000000000000000"
              data-height="55"
              data-margin="0"
              data-font="arial"
              data-displayvalue="false"
              data-textposition="bottom"
            ></canvas>
          </div>
        </div>
      </div>
      <div class="container-jadlog">
        <div class="row">
          <div class="box-between first-line-container">
            <div class="row">
              <p class="font-bold service-name">{{resolveServiceName()}}</p>
            </div>
          </div>
          <div class="wrapper-outer">
            <div class="content">
              <span class="font-little">Track</span>
              <div class="block">1</div>
            </div>
          </div>
          <div class="wrapper-outer">
            <div class="content">
              <h2>MELHOR ENVIO</h2>
            </div>
          </div>
          <div class="wrapper-outer"></div>
        </div>
        <div class="row">
          <div class="bar-code-bottom">
            <canvas
              class="barcode scale"
              data-value="000000000000000000000000000000"
              data-width="1"
              data-height="70"
              data-margin="0"
              data-font="arial"
              data-displayvalue="false"
            ></canvas>
          </div>
        </div>
        <div class="row">
          <div class="bar-code-bottom">
            <canvas
              class="barcode barcode-small"
              data-value="000000000"
              data-height="30"
              data-margin="0"
              data-font="arial"
              data-fontsize="14"
              data-displayvalue="false"
            ></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { maskPhone } from 'commons/js/formatters/Mask';
import { beautifyPostalCode } from 'commons/js/formatters/PostalCode';
import ShippingDefinitions from 'commons/js/ShippingDefinitions';

export default {
  name: "jadlog-shipment-tag-simple",

  mounted() {
    BarCode(".barcode").init();
    this.shippingCompanyIcon = this.iconsPath[this.tag.serviceId];
  },

  computed: {
    tag() {
      return this.$parent.tag;
    },
  },

  data() {
    return {
      iconsPath: {
        [ShippingDefinitions.JADLOG_DOTPACKAGE_ID]: '/images/shipment/jadlog/dot-package.png',
        [ShippingDefinitions.JADLOG_DOTCOM_ID]: '/images/shipment/jadlog/dot-com.png',
        [ShippingDefinitions.JADLOG_DOTPACKAGECENTRALIZADO_ID]: '/images/shipment/jadlog/dot-package.png',
      },
      shippingCompanyIcon: '',
    }
  },

  methods: {
    resolveServiceName() {
      switch (this.tag.serviceId) {
        case ShippingDefinitions.JADLOG_DOTPACKAGE_ID:
        case ShippingDefinitions.JADLOG_DOTPACKAGECENTRALIZADO_ID:
          return 'PACKAGE';
        case ShippingDefinitions.JADLOG_DOTCOM_ID:
          return 'COM';
      }
    },
    maskPhone,
    beautifyPostalCode
  },
};
</script>


<style lang="stylus" scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto:400,700')
.shipment-tag-jadlog-smartlabel
  strong
    font-weight bold
  .shipment-root
    max-width 420px
    margin 0 auto
    font-size 12px
    font-family "Roboto", Arial, Helvetica, sans-serif
    height 515px
    > .row
      .wrapper-outer
        justify-content space-between
        align-items center
        overflow hidden
        .jadlog-header-logo
          width 80px
          display block
          &:first-child
            width 70px
            padding 5px 0
  .font-medium
    font-size 14px
  .font-little
    font-size 10px
  .font-bold
    font-weight 800
  ul
    list-style-type none
    padding 0
    margin 0
  .row
    width 100%
    border-bottom 1px solid #000
  .container-information
    display flex
    border-bottom 1px solid #000
    .wrapper-inner
      .row
        justify-content space-between
        &:last-child
          border-bottom none
        .recipient-contact-wrapper
          width 74%
          word-break break-word
      &:first-child
        max-width 275px
        width 100%
        align-content flex-end
        .box-between
          &:nth-child(2)
            .wrapper-outer
              ul
                li
                  margin 3px 0
          &:last-child
            .wrapper-outer
              ul
                &:first-child
                  max-width 165px
                  padding 5px 0
                  li
                    &:first-child
                      margin-bottom 5px
                &:last-child
                  li
                    display flex
                    justify-content center
                    font-size 60px
                    font-weight 900
      &:nth-child(2)
        width 70px
        border-right 1px solid #000
        border-left 1px solid #000
        .row
          &:last-child
            border none
            height 100%
            position relative
            .wrapper-outer
              transform rotate(90deg)
              position absolute
              top 60px
              width 144px
              left -40px
              padding 0
              overflow-wrap break-word
          &:first-child
            .wrapper-outer
              align-items center
              &:nth-child(2)
                width 255px
            h3
              font-size 35px
            h2
              font-size 60px
              font-weight 900
      &:last-child
        position relative
        width 55px
    .row
      &.box-double-content
        display flex
        justify-content space-between
        height 80px
        padding-top 5px
        .wrapper-outer
          .sender-info
            display grid
            grid-template-rows repeat(3, auto) 1fr
            .sender-obs
              align-self center
  .wrapper-inner
    display flex
    flex-direction column
    .box-between
      &:nth-child(2)
        .wrapper-outer
          height 72px
      &:last-child
        .wrapper-outer
          height 82px
          .shipping-info
            display grid
            grid-template-rows auto 1fr 1fr
            &__type
              margin-bottom 5px
            &__invoice
              grid-row-start 3
  .wrapper-outer
    padding 0 8px
    display flex
    justify-content space-between
  .box-between
    &:nth-child(2)
      .wrapper-outer
        ul
          &:last-child
            .font-little
              margin-bottom 4px
    .wrapper-outer
      ul
        &:last-child
          flex-direction column
          border-left 1px solid #000
          padding-left 8px
          display flex
          width 50px
    &:last-child
      .wrapper-outer
        ul
          &:last-child
            justify-content center
  h4
    margin 0
    & > span
      margin 0 3px
  h1
  h2
  h3
  h5
  p
    margin 0
  .horizontal-wrapper
    display flex
    flex-direction column
    p
      font-size 9px
    &--empty
      min-width 49px
      min-height 95px
  .bar-code-bottom
    width 100%
    overflow hidden
    height 53px
    display flex
    justify-content center
    align-items center
    .img-code-bottom
      width auto
      height 130px
      z-index 0
      position relative
      top -8px
    .scale
      transform scaleX(1.5) !important
  .bar-code
    width 100%
    overflow hidden
    height 250px
    position relative
    .img-code
      transform rotate(90deg) !important
      position relative
      height 38px
      top 107px
      left -90px
      z-index 0
      rect
        height 60px
  .container-jadlog
    .row
      flex-wrap wrap
      display flex
      border-bottom none
      .first-line-container
        padding 0 5px
        > .row
          display flex
          justify-content flex-start
          .font-medium
            margin-right 80px
          .service-name
            margin-left 175px
      .box-between
        display flex
        justify-content space-between
      &:nth-child(2)
      &:nth-child(3)
        flex-grow 0.3
        display flex
        flex-direction column
        p
          text-align center
      &:nth-child(3)
        border-top 1px solid #000
        margin-top 8px
        padding-top 8px
        padding-bottom 8px
      &:first-child
        .wrapper-outer
          display flex
          flex-direction column
          .content
            display flex
            flex-direction column
            justify-content center
          h4
            font-weight 800
        .box-between
          width 100%
      .wrapper-outer
        &:nth-child(3)
          justify-content center
          padding-right 0
          width 200px
          align-items center
          h2
            font-size 18px
            margin-right 10px
        &:nth-child(2)
          max-width 60px
          .content
            height 50px
            display flex
            justify-content center
        &:last-child
          width 70px
          justify-content flex-start
          p
            text-align right
            margin-bottom 10px
    .wrapper-outer
      &:nth-child(2)
        width 225px
  .block
    text-align center
    border 1px solid #000
    width 15px
    height 15px
    display flex
    justify-content center
    align-items center
  .height-large
    height 90px !important
  .height-medium
    height 72px !important
  .space-y
    padding-top 2px
    padding-bottom 20px
  .spacing-small
    margin-top 8px

@media print
  .shipment-tag-jadlog
    .shipment-tag-header
      height 110px !important

      img
        width 85%

      .code
        transform translate(-50%, -50%) scale(1.45) !important

    .shipment-tag-website
      display block
</style>
